<template>
    <v-app>
        <top
            v-if="
                $route.path !== '/login' &&
                $route.path !== '/social-cliente' &&
                $route.path !== '/reset-password' &&
                $route.path !== '/forgot' &&
                $route.path !== '/crear-ticket'
            "
            v-on:toggleDrawer="toggleDrawer"
        ></top>
        <lateral
            v-if="
                $route.path !== '/login' &&
                $route.path !== '/social-cliente' &&
                $route.path !== '/reset-password' &&
                $route.path !== '/forgot' &&
                $route.path !== '/crear-ticket'
            "
            :drawer="drawer"
            v-on:emitInnputDrawer="getInnputDrawer"
        ></lateral>

        <v-main color="purple darken-3">
            <v-container
                fluid
                grid-list-xs
                :class="{
                    'pa-0':
                        $route.path == '/login' ||
                        $route.path !== '/social-cliente' ||
                        $route.path !== '/reset-password' ||
                        ($route.path !== '/forgot' &&
                            $route.path !== '/crear-ticket'),
                }"
            >
                <router-view :key="$route.path"></router-view>
            </v-container>
        </v-main>
    </v-app>
</template>
<style>
.pointer {
    cursor: pointer;
}
</style>
<script>
import Top from "../navs/Top.vue";
import Lateral from "../navs/Lateral.vue";
import auth from "../../auth/auth";
import { mapActions, mapGetters } from "vuex";

export default {
    components: {
        Top,
        Lateral,
    },
    watch: {
        drawer: {
            immediate: true,
            handler: function (n) {},
        },
    },
    data() {
        return {
            drawer: true,
        };
    },
    created() {
        this.getUser();
    },
    methods: {
        ...mapActions({
            setUserRole: "auth/setUserRole",
            setUserData: "auth/setUserData",
            setTickets: "setTickets",
            setRedes: "setRedes",
            setChats: "setChats",
            setMensajesPendientes: "setMensajesPendientes",
        }),
        ...mapGetters({
            userData: "auth/userData",
            userDataTemp: "auth/userDataTemp",
        }),
        getUser() {
            axios.get("/api/current-user").then((res) => {
                const data = res.data;
                const user_id = localStorage.getItem("user_id")?.toString();

                // Dispatch acciones para notificaciones y mensajes
                this.setTickets(res.data.tickets_pendientes);
                this.setRedes(res.data.contenido_pendiente);
                this.setChats();
                this.setMensajesPendientes();

                // Verificar la estructura de datos
                const userRole = data.role || data.user?.role;
                const userId = data.id || data.user?.id;
                const userName = data.name || data.user?.name || data.nombre;
                const userEmail = data.email || data.user?.email;
                const userRoleTfg = data.role_tfg || data.user?.role_tfg;
                const userPermissions = data.permisos || data.user?.permisos;

                if (
                    userRole == 1 &&
                    userId.toString() != user_id &&
                    user_id != null
                )
                    return;

                // Solo almacenamos en localStorage datos no sensibles
                localStorage.setItem("user_name", userName);
                localStorage.setItem("user_email", userEmail);
                localStorage.setItem("user_id", userId);

                const userDataId = this.$store.getters["auth/userData"].id;

                if (userDataId == null) {
                    // Los datos sensibles van a Vuex
                    this.setUserRole(userRole);

                    const token = localStorage.getItem("id_token");
                    this.setUserData({
                        id: userId,
                        name: userName,
                        email: userEmail,
                        role: userRole,
                        role_tfg: userRoleTfg,
                        permissions: userPermissions,
                        token: token,
                    });
                }
            });
        },
        isActive() {
            return false;
        },
        toggleDrawer() {
            this.drawer = !this.drawer;
        },
        getInnputDrawer(e) {
            this.drawer = e;
        },
    },
};
</script>

<style media="screen">
.my-container {
    padding: 1rem;
    background-color: #ffffff;
    border-radius: 7px;
}

.v-content__wrap {
    background-color: #f3f6fd !important;
}

a {
    text-decoration: none;
}

.theme--light.v-application {
    background: rgb(225, 225, 225) !important;
}

.theme--light.v-app-bar.v-toolbar.v-sheet {
    background-color: #ffffff !important;
}

.theme--light.v-data-table
    .v-data-table-header
    th.sortable
    .v-data-table-header__icon {
}
</style>
